// deps
import { Alert, AlertIcon, Box } from "@chakra-ui/react";

/**
 * @typedef {object} Props
 * @property {string | import("react").ReactNode} [detail]
 */

/**
 * @param {Props} props
 */
export default function ErrorDetail(props) {
  const { detail } = props;

  return (
    <>
      {detail && (
        <Box px="1rem" mt="1rem">
          <Alert status="error">
            <AlertIcon />

            {detail}
          </Alert>
        </Box>
      )}
    </>
  );
}
